import DataTable from './dataTable'

/******************************************************************************
 *  Facebook
 *****************************************************************************/

/**
 * @type {Facebook}
 */
export default class Facebook extends DataTable {

    constructor() {
        super('/integrations/facebook/accounts', '/facebook/accounts')
        this.columns = [
            this.prototypes.column('id', 'id', true, true),
            this.prototypes.column('name', 'name', true, true),
        ]
    }

    /**
     * Requisição para remover configuração do Facebook
     * 
     * @param {*} id 
     * @param {*} formdata 
     */
    transferFacebookForms(params) {
        return this.http.put(
            this.constructor.normalize(
                this.constructor.normalize(
                    this.constructor.normalize(
                        this.constructor.normalize(this.resource, '/transfer/forms/from'),
                        params.transfer_id
                    ),
                    '/to'
                ),
                params.receive_id
            )
        ).then(() => {
            return this.delete('', params.transfer_id)
        })
    }
}